export default "https://cdn-static.gokick.com/assets/f7932cbd9535e06fbf9353fcd5d5fd5cf044a6ff/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";